import { getResource } from "./axois.service.curd";

// The menus do not change while the user is logged in, so each one is
// fetched once and shared by the header, sidebar, home page and section pages.
const requests = new Map();

const cached = (key, load) => {
  if (!requests.has(key)) {
    requests.set(
      key,
      load().then((list) => {
        if (!Array.isArray(list)) requests.delete(key); // try again next time
        return list;
      })
    );
  }
  return requests.get(key);
};

/** Sidebar sections (Menu/MemuLevel1) for the operator. */
export const getMenuLevel1 = (appName, opCode) =>
  cached(`1|${appName}|${opCode}`, () =>
    getResource("Menu", "MemuLevel1", { appName, opCode })
  );

/** Pages of one section (Menu/MemuLevel2), e.g. the DATA FEEDING tiles. */
export const getMenuLevel2 = (appName, mnuLevel1, opCode) =>
  cached(`2|${appName}|${mnuLevel1}|${opCode}`, () =>
    getResource("Menu", "MemuLevel2", { appName, mnuLevel1, opCode })
  );

/** Forgets the menus (on logout, or after menu rights are changed). */
export const clearMenus = () => {
  requests.clear();
};
